"use strict";
/**
 * @module Features.Security
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var session_property_validation_1 = require("./../../features/security/session-property-validation");
var security_1 = require("../../../features/security");
/**
 * Implementation of {@link ValuesSessionPropertyValidation}
 *
 * @inheritdoc
 */
var ValuesSessionPropertyValidationImpl = /** @class */ (function (_super) {
    __extends(ValuesSessionPropertyValidationImpl, _super);
    /**
     * Create a ValuesSessionPropertyValidationImpl instance
     *
     * @param  values   the permitted values
     */
    function ValuesSessionPropertyValidationImpl(values) {
        var _this = _super.call(this, security_1.ValidationType.VALUES) || this;
        _this.values = values;
        return _this;
    }
    /**
     * Convert object to string
     *
     * @return a string representation of the ValuesSessionPropertyValidationImpl
     */
    ValuesSessionPropertyValidationImpl.prototype.toString = function () {
        return "SessionPropertyValidation [type=" + this.type + ", values=" + this.values + "]";
    };
    return ValuesSessionPropertyValidationImpl;
}(session_property_validation_1.SessionPropertyValidationImpl));
exports.ValuesSessionPropertyValidationImpl = ValuesSessionPropertyValidationImpl;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/features/security/values-property-validation.js
// module id = 1143
// module chunks = 1